'use strict';

let iframePageInfo = null;
const getIframePageInfo = () => iframePageInfo;
const setIframePageInfo = (value) => (iframePageInfo = value);

exports.getIframePageInfo = getIframePageInfo;
exports.setIframePageInfo = setIframePageInfo;
//# sourceMappingURL=iframePageInfo.js.map
